import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateSubject($data: UpdateSubjectInput!) {
    updateSubject(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateSubject: {
    id: number;
  };
}
